import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NavService } from '../../_services/_nav.service';
import { Convenio } from '../../_models/convenio';
import { ConvenioService } from '../../_services/convenio.service';

@Component( {
  selector: 'app-convenios',
  templateUrl: 'convenios.component.html'
} )
export class ConveniosComponent implements OnInit {

  // Config
  model: Convenio = null;


  // Tabla
  columnas: any[] = [];
  datosTabla: any[] = [];
  cargandoTabla = false;

  // Input y output
  busqueda: '';


  constructor(
    private router: Router,
    private navService: NavService,
    private convenioService: ConvenioService,
  ) {
  }

  ngOnInit() {

    this.columnas = [
      { field: 'numeroContrato', header: this.navService.buscarMensaje( 'CONVENIOS.LBL_NUMEROCONTRATO' ), sort: true },
      { field: 'nombre', header: this.navService.buscarMensaje( 'LBL_NOMBRE' ), sort: true },
      { field: 'fechaDesde', header: this.navService.buscarMensaje( 'LBL_FECHAINICIO' ), sort: false },
      { field: 'fechaHasta', header: this.navService.buscarMensaje( 'LBL_FECHAFIN' ), sort: false },
      { field: 'nombreOpcionDesembolso', header: this.navService.buscarMensaje( 'CONVENIOS.LBL_OPCIONDESEMBOLSO' ), sort: false },
      { field: 'indicadorHabilitado', header: this.navService.buscarMensaje( 'LBL_HABILITADO' ), sort: false },
      { field: 'det', header: this.navService.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.refrescarTabla();
  }

  accionListado( row: any, crud: string ) {
    this.model = row;
    if ( crud === 'DETALLE' ) {
      this.router.navigate( [ 'apl/convenios/detalle/' + row.idConvenio ] ).then();
    } else {
      this.editar( row );
    }
  }

  private editar( row: Convenio ) {
    // Editar o agregar
    if ( row == null ) {
      this.router.navigate( [ 'apl/convenios/agregar/' ] ).then();
    } else {
      this.router.navigate( [ 'apl/convenios/actualizar/' + row.idConvenio ] ).then();
    }
  }

  refrescarTabla() {
    this.cargandoTabla = true;
    this.convenioService.listado()
      .subscribe( x => {
        this.datosTabla = x;
        this.cargandoTabla = false;
      } );
  }

}
